import { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// home pages
const HomeFurniture = lazy(() => import("./pages/home/HomeFurniture"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));

// category pages - Main categories
const TopCategoriesPage = lazy(() => import("./pages/category/TopCategoriesPage"));
const CategoriesPage = lazy(() => import("./pages/category/CategoriesPage"));


// category pages - Lingerie categories
const BrasPage = lazy(() => import("./pages/category/BrasPage"));
const LingeriePage = lazy(() => import("./pages/category/LingeriePage"));
const NightwearPage = lazy(() => import("./pages/category/NightwearPage"));
const PantiesPage = lazy(() => import("./pages/category/PantiesPage"));
const UndergarmentsPage = lazy(() => import("./pages/category/UndergarmentsPage"));
const StockingsPage = lazy(() => import("./pages/category/StockingsPage"));
const TopsPage = lazy(() => import("./pages/category/TopsPage"));
const WinterPage = lazy(() => import("./pages/category/WinterPage"));
const BodyshaperPage = lazy(() => import("./pages/category/BodyshaperPage"));

// category pages - Bra subcategories
const SportsBraPage = lazy(() => import("./pages/category/SportsBraPage"));
const PaddedBraPage = lazy(() => import("./pages/category/PaddedBraPage"));
const CottonNetBraPage = lazy(() => import("./pages/category/CottonNetBraPage"));
const BraSetsPage = lazy(() => import("./pages/category/BraSetsPage"));

// category pages - Nightwear subcategories
const NightiesPage = lazy(() => import("./pages/category/NightiesPage"));
const BoldWearPage = lazy(() => import("./pages/category/BoldWearPage"));
const NightSuitsPage = lazy(() => import("./pages/category/NightSuitsPage"));

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogNoSidebar = lazy(() => import("./pages/blog/BlogNoSidebar"));
const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
const BlogDetailsStandard = lazy(() =>
  import("./pages/blog/BlogDetailsStandard")
);

// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));
const TestCountdown = lazy(() => import("./pages/other/TestCountdown"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
                    <div className="ifilifestyle-preloader-wrapper">
          <div className="ifilifestyle-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            {/* Homepages */}
            <Route path="/" element={<HomeFurniture />} />

            {/* Shop pages */}
            <Route
              path={process.env.PUBLIC_URL + "/shop"}
              element={<ShopGridStandard />}
            />

            {/* Shop product pages */}
            <Route
              path={process.env.PUBLIC_URL + "/product/:slug"}
              element={<Product />}
            />

            {/* Category pages - Main categories */}
            <Route
              path={process.env.PUBLIC_URL + "/top-categories"}
              element={<TopCategoriesPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/categories"}
              element={<CategoriesPage />}
            />
          
            {/* Category pages - Lingerie categories */}
            <Route
              path={process.env.PUBLIC_URL + "/bras"}
              element={<BrasPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/lingerie"}
              element={<LingeriePage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/nightwear"}
              element={<NightwearPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/panties"}
              element={<PantiesPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/undergarments"}
              element={<UndergarmentsPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/stockings"}
              element={<StockingsPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/tops"}
              element={<TopsPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/winter"}
              element={<WinterPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/bodyshaper"}
              element={<BodyshaperPage />}
            />

            {/* Category pages - Bra subcategories */}
            <Route
              path={process.env.PUBLIC_URL + "/bras/sports-bra"}
              element={<SportsBraPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/bras/padded-bra"}
              element={<PaddedBraPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/bras/cotton-net-bra"}
              element={<CottonNetBraPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/bras/bra-sets"}
              element={<BraSetsPage />}
            />

            {/* Category pages - Nightwear subcategories */}
            <Route
              path={process.env.PUBLIC_URL + "/nightwear/nighties"}
              element={<NightiesPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/nightwear/bold-wear"}
              element={<BoldWearPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/nightwear/night-suits"}
              element={<NightSuitsPage />}
            />

            {/* Blog pages */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-standard"}
              element={<BlogStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
              element={<BlogNoSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
              element={<BlogRightSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-details-standard"}
              element={<BlogDetailsStandard />}
            />

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/about"}
              element={<About />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/my-account"}
              element={<MyAccount />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/login-register"}
              element={<LoginRegister />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />
            <Route
              path={process.env.PUBLIC_URL + "/wishlist"}
              element={<Wishlist />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/compare"}
              element={<Compare />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/checkout"}
              element={<Checkout />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/test-countdown"}
              element={<TestCountdown />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
